module.exports = function(aiModule) {
	"use strict";
  aiModule
  .controller('aiConfigurationController', aiConfigurationController)
	aiConfigurationController.$inject = ["keyPressOnlyNumberAndDot","$attrs","aiModalService","watchAllCheckboxesNgTable","slugifyValidator","keyPressSlugify","checkArray","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService","refreshtokenService","$filter","postDataService","alertService","reqursiveService","jQuery","deleteDataService","putDataService","serverError","comunicateBetweenViews","offlineError"]
	
    function aiConfigurationController(keyPressOnlyNumberAndDot,$attrs,aiModalService,watchAllCheckboxesNgTable,slugifyValidator,keyPressSlugify,checkArray,$stateParams,$state,$scope,$rootScope, NgTableParams,getDataService,refreshtokenService,$filter,postDataService,alertService,reqursiveService,jQuery, deleteDataService,putDataService,serverError, comunicateBetweenViews,offlineError) {
        var vmaic = this;
        vmaic.selectedAiFunctionality = {value: 'none'};
        vmaic.selectedAiProvider = {value: 'none'};
        vmaic.selectedAiModel = {value: 'none'};
        vmaic.modelList = [];
        vmaic.providerList = [];
        vmaic.functionalityList = [];
        vmaic.initialStatus = false;
        $scope.parent = $scope.$eval($attrs.parent)
        vmaic.keyPressOnlyNumberAndDot = keyPressOnlyNumberAndDot;
        if($stateParams.id) {
            vmaic.configurationId = $stateParams.id;
        }
        $rootScope.closeEditConfiguration = function() {
            $scope.parent.configurationEdit = false;
            vmaic.configuration = null;
            $scope.parent.getConfigurations(true);
            $state.transitionTo('app.ai_all_configurations', {id: null}, {
              location: true,
              inherit: true,
              relative: $state.$current,
              notify: false
            });
        }
        aiModalService.get('functionality-list', function(data) {
            if(data.results && data.results.length > 0) {
                vmaic.functionalityList = data.results.map(function(item) {
                var name = item.split('-').join(' ');
                name = name.charAt(0).toUpperCase() + name.slice(1);
                return {
                    _id: item,
                    name: name
                }
            });
            }
        });
        vmaic.removeMessage = function(message) {
            vmaic.configuration.extraSettings.messages.splice(vmaic.configuration.extraSettings.messages.indexOf(message), 1);
        }
        vmaic.addNewModel = function() {
            if(!vmaic.newModelName) {
                vmaic.newModelNameRequired = true;
                alertService('danger','Opps! ', 'Model name is required');
                return;
            }
            if(vmaic.selectedAiProvider.value == 'none') {
                alertService('danger','Opps! ', 'Choose provider first');
                return;
            }
            if(vmaic.modelList.find(function(item) {
                return item.name == vmaic.newModelName;
            })) {
                alertService('danger','Opps! ', 'Model already exists');
                return;
            }
            aiModalService.post('models', {vendor: vmaic.selectedAiProvider.value, model: vmaic.newModelName}, function(data) {
                vmaic.modelList.push(data);
                vmaic.newModelName = '';
            }, function(message) {
                alertService('danger','Opps! ', message);
            });
        }
        vmaic.addNewMessage = function() {
            vmaic.configuration.extraSettings.messages.push({
                role: '',
                conditionVars: '',
                content: ''
            });
        }
        
        aiModalService.get('vendors', function(data) {
            if(data && data.length > 0) {
                vmaic.providerList = data;
            }
        });
        vmaic.switchAiProvider = function(provider) {
            if(provider == 'none') {
                vmaic.modelList = [];
                vmaic.selectedAiModel.value = 'none';
                return;
            }
            getAiModels(provider);
        }
        function getAiModels(provider) {
            aiModalService.get('models/'+provider, function(data) {
                if(data && data.length > 0) {
                    vmaic.modelList = data;
                }
            });
        }
        vmaic.updateConfiguration = function() {
            if(!vmaic.configuration.name) {
                alertService('danger','Opps! ', 'Name is required');
                return;
            }
            if(vmaic.selectedAiProvider.value == 'none') {
                alertService('danger','Opps! ', 'Provider is required');
                return;
            }
            if(vmaic.selectedAiModel.value == 'none') {
                alertService('danger','Opps! ', 'Model is required');
                return;
            }
            if(vmaic.selectedAiFunctionality.value == 'none') {
                alertService('danger','Opps! ', 'Functionality is required');
                return;
            }
            if(vmaic.configuration.temperature == 0) {
                alertService('danger','Opps! ', 'Temperature is required');
                return;
            }
            if(!vmaic.configuration.extraSettings || 
                !vmaic.configuration.extraSettings.messages || 
                vmaic.configuration.extraSettings.messages.length == 0) {
                alertService('danger','Opps! ', 'At least one message is required');
                return;
            }
            var hasMessageError = vmaic.configuration.extraSettings.messages.some(function(message, index) {
                if(!message.role) {
                    alertService('danger','Opps! ', 'Role is required for message ' + (index + 1));
                    return true;
                }
                if(!message.content) {
                    alertService('danger','Opps! ', 'Content is required for message ' + (index + 1));
                    return true;
                }
                return false;
            });

            if (hasMessageError) {
                return;
            }
            var httpUrl = vmaic.newConfiguration ? 'configurations' : 'configurations/'+vmaic.configurationId;
            var method = vmaic.newConfiguration ? 'post' : 'put';
            aiModalService[method](httpUrl, {
                name: vmaic.configuration.name,
                aiProvider: vmaic.selectedAiProvider.value,
                model: vmaic.selectedAiModel.value,
                functionality: vmaic.selectedAiFunctionality.value,
                temperature: parseFloat(vmaic.configuration.temperature),
                extraSettings: vmaic.configuration.extraSettings,
                active: vmaic.configuration.active
            }, function(data) {
                if(vmaic.newConfiguration) {
                    alertService('success','Success ', 'Configuration created successfully', 2000);
                    if(data._id) {
                        $state.go('app.ai_all_configurations', {id:data._id});
                    }
                } else {
                    vmaic.configuration = data;
                    alertService('success','Success ', 'Configuration updated successfully', 2000);
                }
                
            }, function(message) {
                alertService('danger','Opps! ', message);
            });
        }
        if(vmaic.configurationId) {
            $rootScope.hasLoaded = false;
            aiModalService.get('configurations/'+vmaic.configurationId,function(data){
                $rootScope.hasLoaded = true;
                vmaic.configuration = data;
                vmaic.selectedAiFunctionality.value = vmaic.configuration.functionality;
                vmaic.selectedAiProvider.value = vmaic.configuration.aiProvider;
                vmaic.selectedAiModel.value = vmaic.configuration.model;
                vmaic.initialStatus = vmaic.configuration.active;
                getAiModels(vmaic.configuration.aiProvider);
            },function(message){
                $rootScope.hasLoaded = true;
                alertService('danger','Opps! ', message);
                $scope.parent.configurationEdit = false;
                $state.transitionTo('app.ai_all_configurations', {id:null}, {
                    location: true,
                    inherit: true,
                    relative: $state.$current,
                    notify: false
                });
            });
        } else {
            vmaic.configuration = {
                extraSettings: {
                    messages: [
                        {
                            role: '',
                            conditionVars: '',
                            content: ''
                        }
                    ]
                },
                active: false,
                name: '',
                temperature: 0.5
            }
            vmaic.newConfiguration = true;
        }
        if(!window.navigator.onLine) {
        offlineError('refresh')
        return
        }
    }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/aiModule/create-edit-configuration/js/aiConfigurationController.js
// module id = 488
// module chunks = 0